import * as constants from './constants';
import axiosInstance from "../../../utils/request";


export const changeStatus = (status) => ({
    type: constants.CHANGE_STATUS,
    status
});



export const queueStatus = () => {
    return (dispatch) => {
        axiosInstance.get('/queue/status').then((response) => {
            if (response) {
                dispatch(changeStatus(response));
            }
        }).catch((e) => {
            return {};
        })
    }
}